import React, { useEffect, useState } from 'react'
import { Form } from 'react-final-form'
import { useSearchCallOutcomeMutation } from '../../../services'
import { UspConfigurationCallOutcomeViewResult } from '../../../models'
import Header from '../components/Header/Header'
import CallOutcomesTable from './components/CallOutcomesTable'
import AddEditCallOutcomes from './components/AddEditCallOutcomes'
import { Button, Card, Container, Grid } from '@mui/material'
import CustomBreadcrumbs from '../../../components/custom-breadcrumbs/custom-breadcrumbs'
import Iconify from '../../../components/iconify'

const CommunicationCallOutcome = () => {
  const [rowData, setRowData] = useState({})
  const [openAddEditModal, setOpenAddEditModal] = useState(false)
  const [type, setType] = useState('')
  const [searchCallOutcome, { data, isLoading }] = useSearchCallOutcomeMutation()
  const [callOutcomeData, setCallOutcomeData] = useState<UspConfigurationCallOutcomeViewResult[]>([])

  const handleSubmit = (values?: any) => {
    searchCallOutcome({
      simpleSearch: {
        searchString: values?.searhString,
        isIncludeInactive: values?.isIncludeInactive,
      },
    })
  }

  const handleOpenModal = () => {
    setOpenAddEditModal(true)
    setType('add')
  }

  const handleCloseModal = () => {
    setOpenAddEditModal(false)
  }

  useEffect(() => {
    if (data) {
      setCallOutcomeData(data)
    }
  }, [data])

  return (
    <Container>
      <CustomBreadcrumbs
        heading='Call Outcomes'
        links={[
          {
            name: 'List',
          },
        ]}
        action={
          <Button onClick={handleOpenModal} variant='contained' startIcon={<Iconify icon='mingcute:add-line' />}>
            Add new
          </Button>
        }
        sx={{
          mb: {
            xs: 3,
            md: 5,
          },
        }}
      />
      <Form onSubmit={handleSubmit} initialValues={{ searhString: null, isIncludeInactive: false }}>
        {({ handleSubmit, form: { submit } }: any) => (
          <>
            <form onSubmit={handleSubmit}>
              <Card>
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <Header submit={submit} title='' handleOpenModal={handleOpenModal} />
                  </Grid>
                  <Grid item xs={12}>
                    <CallOutcomesTable
                      setOpenAddEditModal={setOpenAddEditModal}
                      setType={setType}
                      setRowData={setRowData}
                      handleOpenModal={handleOpenModal}
                      loading={isLoading}
                      data={callOutcomeData}
                      setData={setCallOutcomeData}
                    />
                  </Grid>
                </Grid>
              </Card>
            </form>
            <AddEditCallOutcomes
              submit={submit}
              open={openAddEditModal}
              onClose={handleCloseModal}
              type={type}
              rowData={rowData as UspConfigurationCallOutcomeViewResult}
            />
          </>
        )}
      </Form>
    </Container>
  )
}

export default CommunicationCallOutcome
